import { addContentPath } from '../util/pathUtil';

export const devModuleCustomFiles = [
  `css!${addContentPath('/cloudstore/config/devStatic/devModuleStyle.css')}?v=${Date.now()}`,
  `${addContentPath('/cloudstore/config/devStatic/devModuleCustom.js')}?v=${Date.now()}`,
];

export const ecComFiles = [addContentPath('/cloudstore/resource/pc/com/v1/ecCom.min.js')];

export const comMobxFiles = [addContentPath('/spa/coms/index.mobx.css'), addContentPath('/spa/coms/index.mobx.js')];

export const portalPublicFiles = [
  addContentPath('/spa/portal/public/index.css'),
  addContentPath('/spa/portal/public/index.js'),
];



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/constants/files.js